import createIcon from '../../createIcon';

/**
 * @component @name WbAuto
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNi45NDk2MSAxMi42NUg5LjI0OTYxTDguMDk5NjEgOUw2Ljk0OTYxIDEyLjY1Wk0yMi4wOTk2IDdMMjAuODk5NiAxMy4yOUwxOS4zOTk2IDdIMTcuNzk5NkwxNi4zMDk2IDEzLjI5TDE1LjA5OTYgN0gxNC4zMzk2QzEyLjg2OTYgNS4xNyAxMC42Mjk2IDQgOC4wOTk2MSA0QzMuNjc5NjEgNCAwLjA5OTYwOTQgNy41OCAwLjA5OTYwOTQgMTJDMC4wOTk2MDk0IDE2LjQyIDMuNjc5NjEgMjAgOC4wOTk2MSAyMEMxMS4yMjk2IDIwIDEzLjkzOTYgMTguMTkgMTUuMjQ5NiAxNS41N0wxNS4zNDk2IDE2SDE3LjA5OTZMMTguNTk5NiA5LjlMMjAuMDk5NiAxNkgyMS44NDk2TDIzLjg5OTYgN0gyMi4wOTk2Wk0xMC4zOTk2IDE2TDkuNjk5NjEgMTRINi40OTk2MUw1Ljc5OTYxIDE2SDMuODk5NjFMNy4wOTk2MSA3SDkuMDk5NjFMMTIuMjk5NiAxNkgxMC4zOTk2WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const WbAuto = createIcon('WbAuto', [
  [
    'path',
    {
      d: 'M6.94961 12.65H9.24961L8.09961 9L6.94961 12.65ZM22.0996 7L20.8996 13.29L19.3996 7H17.7996L16.3096 13.29L15.0996 7H14.3396C12.8696 5.17 10.6296 4 8.09961 4C3.67961 4 0.0996094 7.58 0.0996094 12C0.0996094 16.42 3.67961 20 8.09961 20C11.2296 20 13.9396 18.19 15.2496 15.57L15.3496 16H17.0996L18.5996 9.9L20.0996 16H21.8496L23.8996 7H22.0996ZM10.3996 16L9.69961 14H6.49961L5.79961 16H3.89961L7.09961 7H9.09961L12.2996 16H10.3996Z',
      key: 'tujt3a',
    },
  ],
]);

export default WbAuto;
